import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

import { defaultPublicationValues, publicationSchema } from '../../Publication/model/PublicationSchema';

export const paperSchema = publicationSchema.extend({
  journal: identitySchema,
  journalType: identitySchema,
  volume: z.string().nullable(),
  volumeNo: z.string().nullable(),
});

export const defaultPaperValues: DefaultValues<PaperSchema> = {
  volume: '',
  volumeNo: '',
  ...defaultPublicationValues,
};

export type PaperSchema = z.infer<typeof paperSchema>;
